import { useMemo, useState } from "react"
import { useCityGroups } from "./useCityGroup"

export const useAreaViewTab = () => {
    const { data: cityGroups } = useCityGroups()
    const areaTabs = useMemo(
        () => [
            {
                title: "すべて",
                data: undefined
            },
            ...(cityGroups?.map(cityGroup => ({
                title: cityGroup.name,
                data: {
                    id: cityGroup.id
                }
            })) ?? [])
        ],
        [cityGroups]
    )

    const [selectedCityGroupId, setSelectedCityGroupId] = useState<
        string | undefined
    >(undefined)

    return {
        areaTabs,
        selectedCityGroupId,
        onCityGroupIdSelected: setSelectedCityGroupId
    }
}
